// saga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import { createDesignation, deleteDesignation, getDesignationApi, updateDesignation } from '../../api/DesignationApi'; // Adjust the path as needed
import {
    getDesignationSuccess,
    getDesignationFailure,
    createDesignationSuccess,
    createDesignationFailure,
    updateDesignationSuccess,
    updateDesignationFailure,
    deleteDesignationSuccess,
    deleteDesignationFailure,
} from './actions';

// Saga to handle fetching Designations
function* fetchDesignationSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(getDesignationApi, action.payload);
        yield put(getDesignationSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(getDesignationFailure(errorMessage));
    }
}

// // Saga to handle creating a Designation
function* createDesignationSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(createDesignation, action.payload);
        yield put(createDesignationSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(createDesignationFailure(errorMessage));
    }
}

// // Saga to handle updating a Designation
function* updateDesignationSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(updateDesignation, action.payload.data, action.payload.id);
        yield put(updateDesignationSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(updateDesignationFailure(errorMessage));
    }
}

// // Saga to handle updating a Designation
function* deleteDesignationSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(deleteDesignation, action.payload.id);
        yield put(deleteDesignationSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';
        yield put(deleteDesignationFailure(errorMessage));
    }
}

export default function* DesignationSaga() {
    yield takeEvery('GET_DESIGNATION_REQUEST', fetchDesignationSaga);
    yield takeEvery('CREATE_DESIGNATION_REQUEST', createDesignationSaga);
    yield takeEvery('UPDATE_DESIGNATION_REQUEST', updateDesignationSaga);
    yield takeEvery('DELETE_DESIGNATION_REQUEST', deleteDesignationSaga);
}
